import React from "react";

export function DocumentIcon() {
    return <svg
        data-testid={"icon-document"}
        width="88"
        height="88"
        viewBox="0 0 68 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mb-8 sm:mb-12"
    >
        <path
            d="M17.847 88C15.611 88 13.744 87.246 12.246 85.739C10.749 84.231 10 82.353 10 80.102V7.898C10 5.647 10.749 3.769 12.246 2.261C13.744 0.754 15.611 0 17.847 0H56.143L78 22V80.102C78 82.353 77.251 84.231 75.754 85.739C74.256 87.246 72.389 88 70.153 88H17.847ZM53.714 24.444H73.143L53.714 4.889V24.444ZM27 70.889H61V66H27V70.889ZM27 51.333H61V46.444H27V51.333Z"
            fill="#DEDEDE"
        />
    </svg>;
}